import DeviceRoute from './device-route-container'
export default DeviceRoute
